import { Directive, EventEmitter, OnInit, Output } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { PAGE_SIZE_DEFAULT, PAGE_SIZE_OPTIONS, PageRequest } from '@shared/models/pagination';

@Directive({
    selector: '[matPaginatorPersisted]',
    standalone: false
})
export class MatPaginatorPersistedDirective implements OnInit {

    public static readonly pageSizeOptionsDefault = [...PAGE_SIZE_OPTIONS];
    public static readonly pageSizeDefault = PAGE_SIZE_DEFAULT;
    public static readonly pageIndexDefault = 0;

    @Output() pageSizeChanged = new EventEmitter<PageEvent>();

    constructor(private element: MatPaginator) {
        this.element.pageSize = PageRequest.pageSize;
        this.element.pageSizeOptions = MatPaginatorPersistedDirective.pageSizeOptionsDefault;
        this.element.pageIndex = MatPaginatorPersistedDirective.pageIndexDefault;
    }

    ngOnInit(): void {
        this.element.page.subscribe((page: PageEvent) => {
            PageRequest.pageSize = page.pageSize;
            this.pageSizeChanged.emit(page);
        });
    }
}
